/** Fraction of page width/height used as max bounds when placing library images (medium size). */
const MEDIUM_IMAGE_PAGE_FRACTION = 0.38;

/**
 * Fit a bitmap into a medium box on the artboard (never larger than ~38% of page).
 * @returns {{ width: number, height: number, scale: number }}
 */
export function computeMediumImageDimensions(naturalWidth, naturalHeight, pageWidth, pageHeight) {
  const iw = Math.max(1, naturalWidth);
  const ih = Math.max(1, naturalHeight);
  const pw = Math.max(1, pageWidth);
  const ph = Math.max(1, pageHeight);
  const maxW = Math.max(96, pw * MEDIUM_IMAGE_PAGE_FRACTION);
  const maxH = Math.max(96, ph * MEDIUM_IMAGE_PAGE_FRACTION);
  const scale = Math.min(maxW / iw, maxH / ih);
  return { width: iw * scale, height: ih * scale, scale };
}
